import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateTasksFromAssignments } from 'scenes/Timelines/services/postCreateTasksFromAssignments.service';

export const createTasksFromAssignments = createAsyncThunk(
  'timelines/createTasksFromAssignments',
  async ({ projectId, timelineId, assignmentIds }) => {
    const response = await postCreateTasksFromAssignments(
      projectId,
      timelineId,
      assignmentIds
    );
    return response;
  }
);
